import css from 'styled-jsx/css';

const styles = css`/* stylelint-disable a11y/media-prefers-reduced-motion */
:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New design variables introduced 11-12-2019 */

    /* New design variables introduced 7-16-2020 */
}
:root {
    @lost gutter 24px;

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    @custom-media --small-up (min-width: 322px);
    @custom-media --small-down (max-width: 320px);
    @custom-media --small-only (max-width: 320px);

    @custom-media --medium-up (min-width: 722px);
    @custom-media --medium-down (max-width: 720px);
    @custom-media --medium-only (max-width: 720px) and (min-width: 321.001);

    @custom-media --large-up (min-width: 1082px);
    @custom-media --large-down (max-width: 1080px);
    @custom-media --large-only (max-width: 1080px) and (min-width: 721.001);

    @custom-media --xlarge-up (min-width: 1442px);
    @custom-media --xlarge-down (max-width: 1440px);
    @custom-media --xlarge-only (max-width: 1440px) and (min-width: 1081.001);

    @custom-media --xxlarge-up (min-width: 1922px);
    @custom-media --xxlarge-down (max-width: 1920px);
    @custom-media --xxlarge-only (max-width: 1920px) and (min-width: 1441.001);

    @custom-media --small-up-height (min-height: 322px);
    @custom-media --small-down-height (max-height: 320px);
    @custom-media --small-only-height (max-height: 320px);

    @custom-media --medium-up-height (min-height: 722px);
    @custom-media --medium-down-height (max-height: 720px);
    @custom-media --medium-only-height (max-height: 720px) and (min-height: 321.001);

    @custom-media --large-up-height (min-height: 1082px);
    @custom-media --large-down-height (max-height: 1080px);
    @custom-media --large-only-height (max-height: 1080px) and (min-height: 721.001);

    @custom-media --xlarge-up-height (min-height: 1442px);
    @custom-media --xlarge-down-height (max-height: 1440px);
    @custom-media --xlarge-only-height (max-height: 1440px) and (min-height: 1081.001);

    @custom-media --xxlarge-up-height (min-height: 1922px);
    @custom-media --xxlarge-down-height (max-height: 1920px);
    @custom-media --xxlarge-only-height (max-height: 1920px) and (min-height: 1441.001);
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
button {
    outline: 0;
    border: 0;
    background: none;
    padding: 0;
    font-family: inherit;
    font-style: inherit;
    cursor: pointer;
}
.spinner-container {
  display: flex;
  margin: 150px auto;
  align-items: center;
  justify-content: center;
}
.lds-default {
  display: inline-blo1ck;
  position: relative;
  width: 80px;
  height: 80px;
  transform: scale(1.5);
}
@media screen and (prefers-reduced-motion: reduce) {
.lds-default div {
  position: absolute;
  width: 5px;
  height: 5px;
  background: #05c3de;
  border-radius: 50%;
  -webkit-animation: none;
          animation: none;
}
}
.lds-default div {
  position: absolute;
  width: 5px;
  height: 5px;
  background: #05c3de;
  border-radius: 50%;
  -webkit-animation: lds-default 1.2s linear infinite;
          animation: lds-default 1.2s linear infinite;
}
.lds-default div:nth-child(1) {
  -webkit-animation-delay: 0s;
          animation-delay: 0s;
  top: 37px;
  left: 66px;
}
.lds-default div:nth-child(2) {
  -webkit-animation-delay: -0.1s;
          animation-delay: -0.1s;
  top: 22px;
  left: 62px;
}
.lds-default div:nth-child(3) {
  -webkit-animation-delay: -0.2s;
          animation-delay: -0.2s;
  top: 11px;
  left: 52px;
}
.lds-default div:nth-child(4) {
  -webkit-animation-delay: -0.3s;
          animation-delay: -0.3s;
  top: 7px;
  left: 37px;
}
.lds-default div:nth-child(5) {
  -webkit-animation-delay: -0.4s;
          animation-delay: -0.4s;
  top: 11px;
  left: 22px;
}
.lds-default div:nth-child(6) {
  -webkit-animation-delay: -0.5s;
          animation-delay: -0.5s;
  top: 22px;
  left: 11px;
}
.lds-default div:nth-child(7) {
  -webkit-animation-delay: -0.6s;
          animation-delay: -0.6s;
  top: 37px;
  left: 7px;
}
.lds-default div:nth-child(8) {
  -webkit-animation-delay: -0.7s;
          animation-delay: -0.7s;
  top: 52px;
  left: 11px;
}
.lds-default div:nth-child(9) {
  -webkit-animation-delay: -0.8s;
          animation-delay: -0.8s;
  top: 62px;
  left: 22px;
}
.lds-default div:nth-child(10) {
  -webkit-animation-delay: -0.9s;
          animation-delay: -0.9s;
  top: 66px;
  left: 37px;
}
.lds-default div:nth-child(11) {
  -webkit-animation-delay: -1s;
          animation-delay: -1s;
  top: 62px;
  left: 52px;
}
.lds-default div:nth-child(12) {
  -webkit-animation-delay: -1.1s;
          animation-delay: -1.1s;
  top: 52px;
  left: 62px;
}
@-webkit-keyframes lds-default {
  0% {
    background-color: #ace3ea;
    transform: scale(1);
  }
  20% {
    background-color: #ace3ea;
    transform: scale(1);
  }
  80% {
    background-color: #ace3ea;
    transform: scale(1);
  }
  100% {
    background-color: #ace3ea;
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
    background-color: #05c3de;
  }
}
@keyframes lds-default {
  0% {
    background-color: #ace3ea;
    transform: scale(1);
  }
  20% {
    background-color: #ace3ea;
    transform: scale(1);
  }
  80% {
    background-color: #ace3ea;
    transform: scale(1);
  }
  100% {
    background-color: #ace3ea;
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
    background-color: #05c3de;
  }
}
`;

export default styles;